import { compose } from 'recompose'
import { connect } from 'react-redux'
import { withLocalization } from 'hocs/localization'
import { getRegistrationStep } from 'redux-app/selectors/auth'
import CreateProfileProgress from './CreateProfileProgress'

export default compose(
  withLocalization('profile.progress'),
  connect(
    state => ({
      step: getRegistrationStep(state),
    }),
    null,
  ),
)(CreateProfileProgress)
